module.exports = __webpack_public_path__ + "static/players-7aeb828340ab363e8d34cfbc5b3dbd40.svg";